var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrugTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 42,
    viewBox: "0 0 49 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2104 9.02048L7.39417 37.9805H41.0165L24.2003 9.02048M24.2003 0.980469L48.0063 41.9805H0.404297L24.2104 0.980469H24.2003Z",
    fill: "#797770"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrugTriangle);
export default __webpack_public_path__ + "static/media/drug-triangle.32092c6335efd67437d4cf09134a3998.svg";
export { ForwardRef as ReactComponent };